import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from 'components/common/Text'
import { BLUE, LIGHTER_GRAY } from '../../../../styles'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  margin-top: 10px;
  padding-bottom: 10px;
`
const ColorField = styled.div`
  background-color: ${props => props.color};
  margin-right: 10px;
  width: 32px;
  height: 18px;
  border-radius: 2px;
  border: solid ${props => props.selected ? 2 : 1}px ${props => props.selected ? BLUE : LIGHTER_GRAY};
  cursor: pointer;
`
const NameContainer = styled.div`
  display: flex;
  width: 125px;
  height: 30px;
  align-items: center;
  justify-content: space-between;
`
const ResetTextContainer = styled.div`
  margin-left: 30px;
  cursor: pointer;
`

class SPColor extends Component {

  onClick = (color) => {
    const { onChange, currentValue } = this.props
    return () => {
      if (color === currentValue.color) {
        onChange({})
      } else {
        onChange({color})
      }
    }
  }

  onReset = () => {
    const { onChange } = this.props
    onChange({})
  }

  render () {
    const { currentValue, colors, title } = this.props
    return (
      <Container>
        <NameContainer>
          <Text size='medium'>{title}</Text>
        </NameContainer>
        {colors.map((color, i) => {
          return (
            <ColorField
              key={i}
              color={color}
              selected={color === currentValue.color}
              onClick={this.onClick(color)}
            />
          )
        })}
        <ResetTextContainer
          onClick={this.onReset}
        >
          <Text size='medium'>RESET</Text>
        </ResetTextContainer>
      </Container>
    )
  }
}

SPColor.defaultProps = {
  currentValue: {},
  colors: [],
  onChange: () => null,
  title: ''
}

SPColor.propTypes = {
  currentValue: PropTypes.object,
  colors: PropTypes.array,
  onChange: PropTypes.func,
  title: PropTypes.string
}

export default SPColor



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPColor.js